import React from "react";
import { InputGroup } from "reactstrap";

const ConditionalInputGroup = (props) => {
  const { condition, className, id } = props;

  return condition ? (
    <InputGroup id={id} className={className}>
      {props.children}
    </InputGroup>) : props.children
}

export default ConditionalInputGroup;